<template>
    <div v-show="playerBaseData !== undefined"
         class="player-wrapper"
         @mouseenter="showPlayerBody = true"
         @mouseleave="showPlayerBody = false;showVolume = false">
        <div class="lock-icon-mask">
            <div class="lock-icon"
                 @click="lockOnOff = !lockOnOff">
                <img :src="lockOnOff ? require('@/assets/player/lock.png')
                : require('@/assets/player/unlock.png') ">
            </div>
        </div>
        <div :class="{'fix-height': lockOnOff || showCate || showPlayerBody || showBodySec}" class="player-body-mask">
            <div class="player-body">
                <div class="player-actives-mask">
                    <img :src="playerBaseData ? playerBaseData.cover : ''" class="resource-cover">
                    <div ref="progressBarMask"
                         class="progress-bar-mask"
                         @click="changePlayedTime">
                        <div :style="{width: `${playedScale}%`,background: themeColor}"
                             class="percent-bar"/>
                    </div>
                    <div class="infos-actives">
                        <h5>{{ playingName }}</h5>
                        <div class="control-btns">
                            <img src="@/assets/player/next.png"
                                 class="prev"
                                 @click="changePlay('prev')">
                            <div class="status"
                                 @click="togglePlayStatus">
                                <img v-if="playingStatus"
                                     :class="{loadingKeyFrame:playingStatus === 'loading'}"
                                     :src="require(`@/assets/player/${playingStatus}.png`)"
                                     :style="{background: themeColor}"
                                     class="status">
                            </div>
                            <img src="@/assets/player/next.png"
                                 class="next"
                                 @click="changePlay('next')">
                        </div>
                        <div class="other-btns">
                            <div class="time-info">
                                {{ `${$tools.formatTime(playedTime)}/${$tools.formatTime(totalDuration)}` }}
                            </div>
                            <img :src="playerVolume > 0 ? require('@/assets/player/unmute.png')
                                 : require('@/assets/player/mute.png') "
                                 class="volume-btns"
                                 @mouseenter="showVolume = true"
                                 @mouseleave="showVolume = false"
                                 @click="toggleMute">
                            <img src="@/assets/player/playlist.png"
                                 class="catelog-btns"
                                 @click="showCate = !showCate">
                        </div>
                    </div>
                </div>
                <div :style="{ maxHeight: showCate ? '280px' : 0 }" class="catelog-list-mask">
                    <div ref="catelogListMask"
                         class="catelog-list-body">
                        <div class="catelog-list">
                            <div v-for="(item,index) in playerCateLogList"
                                 :key="index"
                                 class="catelog-item">
                                <i :style="{color: item.Sequence === playingSequence ? themeColor : ''}">
                                    {{ index + 1 }}
                                </i>
                                <p :style="{color: item.Sequence === playingSequence ? themeColor : ''}"
                                   @click="changePlayingSequence(item)">
                                    {{ `${playerBaseData ? playerBaseData.name : ''} - ${item.Title}` }}
                                </p>
                                <img src="@/assets/close.png"
                                     class="delete-icon"
                                     @click="deleteCate(index)">
                            </div>
                        </div>
                    </div>
                </div>
                <div :style="{ maxHeight: showVolume ? '200px' : 0}"
                     class="volume-actives-mask"
                     @mouseenter="showVolume = true"
                     @mouseleave="showVolume = false">
                    <div class="has-arrow-wrapper"
                         @mousemove.stop="volumeDragMove"
                         @mouseup.stop="volumeDragUp"
                         @mouseleave="volumeDragStartY = null">
                        <div class="actives-body">
                            <div class="volume-progress">
                                <div ref="volumePercent"
                                     :style="{height: `${volumePercentHeight}px`,background: themeColor}"
                                     class="volume-percent">
                                    <div :style="{background: themeColor}"
                                         class="volume-drag-point"
                                         @mousedown.stop="volumeDragStart"/>
                                </div>
                                <div :style="{background: themeColor}" class="volume-percent-empty"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AudioPlayer from '@/plugins/audio-player'
    import BScroll from 'better-scroll'

    export default {
        components: {
        },
        props: {
            baseInfo: {
                type: Object,
                default: undefined
            },
            catelogList: {
                type: Array,
                default () {
                    return []
                }
            }
        },
        data () {
            return {
                showPlayerBody: true,
                lockOnOff: false,
                showCate: false,
                playingStatus: 'loading',
                totalDuration: 0,
                playedTime: 0,
                mediaPlayerObj: undefined,
                showBodySec: false,
                showVolume: false,
                volumeDragStartY: null,
                playerVolume: 1
            }
        },
        computed: {
            playerBaseData () {
                return this.$store.state.playerBaseData
            },
            playerCateLogList () {
                return this.$store.state.playerCateLogList
            },
            playingSequence () {
                return this.$store.state.playingSequence
            },
            playedScale () {
                const { totalDuration, playedTime } = this
                if (totalDuration > 0) {
                    return playedTime / totalDuration * 100
                }
                return 0
            },
            playingName () {
                const { playerCateLogList, playingSequence } = this
                const item = playerCateLogList.find((e) => {
                    return e.Sequence === playingSequence
                })
                return item ? item.Title : ''
            },
            volumePercentHeight () {
                const { playerVolume } = this
                const baseHeight = 100
                return playerVolume * baseHeight
            },
            themeColor () {
                return this.$store.state.themeColor
            }
        },
        watch: {
            playingSequence (newVal) {
                debugger
                this.setDuration(newVal)
                if (newVal === -1) {
                    this.togglePlayStatus()
                    return
                }
                this.getSubResUrl(newVal)
            },
            playerBaseData (newVal) {
                if (newVal === undefined) {
                    debugger
                    this.mediaPlayerObj.pause()
                }
            }
        },
        mounted () {
            this.initBScroll()
            this.initPlayer([{
                src: ''
            }])
        },
        methods: {
            initBScroll () {
                this.$nextTick(() => {
                    this.detailAudioBScroll = new BScroll(this.$refs.catelogListMask, {
                        bounce: false,
                        click: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                })
            },
            initPlayer (mediaUrlArr) {
                const vm = this
                if (this.mediaPlayerObj) {
                    this.mediaPlayerObj.pause()
                    this.startPlayingTime = undefined
                    this.mediaPlayerObj.$.list[0].src = mediaUrlArr[0].src
                    this.mediaPlayerObj.play(0)
                    return
                }
                this.mediaPlayerObj = new AudioPlayer(mediaUrlArr, {
                    onloadstart () {
                        vm.playingStatus = 'loading'
                    },
                    onplaying () {
                        vm.playingStatus = 'play'
                    },
                    oncanplay () {
                        vm.mediaPlayerObj.canPlay = true
                    },
                    onplay () {
                        vm.playingStatus = 'play'
                        vm.showBodySec = true
                        setTimeout(() => {
                            vm.showBodySec = false
                        }, 1400)
                    },
                    onpause () {
                        vm.playingStatus = 'pause'
                    },
                    onended () {
                    },
                    onvolumechange () {
                        vm.playerVolume = vm.mediaPlayerObj.volume()
                    },
                    ontimeupdate (e) {
                        const currentSec = Math.round(e.target.currentTime)
                        const { totalDuration } = vm
                        vm.playedTime = currentSec <= totalDuration ? currentSec : totalDuration
                    }
                })
                // this.mediaPlayerObj.play(0)
            },
            changePlayedTime (ev) {
                const clickX = ev.layerX
                const { progressBarMask } = this.$refs
                const baseX = progressBarMask.clientWidth

                const { totalDuration } = this
                let scale = clickX / baseX
                if (scale > 1) {
                    scale = 1
                }
                if (scale < 0) {
                    scale = 0
                }
                const time = totalDuration * scale
                this.mediaPlayerObj.currentTime(time)
            },
            changePlayingSequence (item) {
                const { playingSequence } = this
                const sequence = item ? item.Sequence : undefined
                if (sequence !== playingSequence) {
                    this.$store.commit('setShowPlayingSequence', sequence)
                }
            },
            togglePlayStatus () {
                if (this.mediaPlayerObj && this.mediaPlayerObj.canPlay) {
                    const { playingStatus } = this
                    if (playingStatus === 'play') {
                        this.mediaPlayerObj.pause()
                    } else {
                        this.mediaPlayerObj.play()
                    }
                }
            },
            changePlay (type) {
                const { playerCateLogList, playingSequence } = this

                if (playerCateLogList <= 0) {
                    return
                }

                const indexNow = playerCateLogList.findIndex((e) => {
                    return e.Sequence === playingSequence
                })
                let newIndex
                if (type === 'next') {
                    newIndex = indexNow + 1
                } else if (type === 'prev') {
                    newIndex = indexNow - 1
                }

                if (newIndex < 0) {
                    newIndex = playerCateLogList.length - 1
                }
                if (newIndex > playerCateLogList.length - 1) {
                    newIndex = 0
                }

                this.changePlayingSequence(playerCateLogList[newIndex])
            },
            setDuration (sequence) {
                const { playerCateLogList } = this
                const item = playerCateLogList.find((e) => {
                    return e.Sequence === sequence
                })
                this.totalDuration = item ? item.Duration : 0
                this.playedTime = 0
            },
            deleteCate (index) {
                const { playerCateLogList, playingSequence } = this
                const item = playerCateLogList[index]

                const newCate = playerCateLogList.filter((e, i) => {
                    return i !== index
                })

                this.$store.commit('setPlayerCateLogList', newCate)

                if (newCate.length <= 0) {
                    this.$store.commit('setShowPlayingSequence', -1)
                    return
                }
                if (item.Sequence === playingSequence) {
                    this.changePlay('next')
                }
            },
            volumeDragStart (ev) {
                this.volumeDragStartY = ev.clientY
            },
            volumeDragMove (ev) {
                const { volumePercent } = this.$refs
                const { volumeDragStartY } = this
                if (volumeDragStartY === null) {
                    return
                }
                const baseHeight = 100
                const perHeight = volumePercent.clientHeight
                const newHeight = perHeight - (ev.clientY - volumeDragStartY)
                let newVolume = newHeight / baseHeight
                if (newVolume < 0) {
                    newVolume = 0
                }
                if (newVolume > 1) {
                    newVolume = 1
                }
                this.mediaPlayerObj.volume(newVolume)
                this.volumeDragStartY = ev.clientY
            },
            volumeDragUp () {
                this.volumeDragStartY = null
            },
            toggleMute () {
                const volume = this.mediaPlayerObj.volume()
                if (volume !== 0) {
                    this.mediaPlayerObj.oldVolumeHB = volume
                    this.mediaPlayerObj.volume(0)
                } else {
                    this.mediaPlayerObj.volume(this.mediaPlayerObj.oldVolumeHB)
                }
            },
            async getSubResUrl (playingSequence) {
                try {
                    const { playerBaseData } = this
                    const id = playerBaseData ? playerBaseData.id : undefined
                    if (!id) {
                        return
                    }
                    const { Data } = await this.$apis('audio')
                        .getSubResUrl(id, playingSequence)
                    if (Data) {
                        const arr = [{ src: Data }]
                        this.initPlayer(arr)
                    }
                } catch (error) {
                    const { Code } = error
                    if (Code === 4) {
                        this.$store.commit('setShowLoginRegister', true)
                    }
                    this.$tools.checkBindMobile(Code);
                    console.log(error)
                }
            }
        }
    }
</script>
<style type="text/css">
    @keyframes loadingRotate {
        form {transform:rotate(0deg);}
        to    {transform:rotate(180deg);}
    }
</style>
<style lang="scss" scoped>
    .player-wrapper {
        width: 100%;
        min-width: 1140px;
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        color: rgba(255, 255, 255, 0.77);
        font-size: 14px;
    }

    .lock-icon-mask {
        position: relative;
        bottom: 0;
        align-self: flex-end;
        width: 40px;
        height: 18px;
        box-sizing: border-box;
        padding-top: 2px;
        z-index: 3;
        margin-right: 50px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .lock-icon {
        width: 34px;
        height: 14px;
        padding-top: 2px;
        background: rgb(54, 60, 67);
        border-top-left-radius: 50%;
        border-top-right-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transform: rotateX(5deg);
        overflow: hidden;

        img {
            width: 10px;
            height: 10px;
        }
    }

    .player-body-mask {
        width: 100%;
        margin: 0 auto;
        height: 0;
        transition: height .2s .4s;
        overflow: hidden;
        background: #363c43;
    }

    .player-body-mask.fix-height {
        height: 80px;
        overflow: visible;
        transition: height .2s;
    }

    .player-body {
        height: 100%;
        width: 1140px;
        margin: 0 auto;
        position: relative;
    }

    .player-actives-mask {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        position: relative;
        overflow: hidden;

        .resource-cover {
            width: 80px;
            height: 80px;
            background: #f6f6f6;
        }

        .progress-bar-mask {
            width: 1060px;
            height: 10px;
            position: absolute;
            top: 0;
            right: 0;
            background: #595e63;
            cursor: pointer;
        }

        .percent-bar {
            height: 100%;
            width: 10%;
            max-width: 100%;
            background: #0084ff;
        }

        .infos-actives {
            width: 1060px;
            height: 70px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            h5 {
                width: 400px;
                box-sizing: border-box;
                padding-left: 16px;
                font-size: 15px;
            }

            img {
                cursor: pointer;
            }
        }

        .control-btns {
            width: 260px;
            height: 70px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            img {
                display: block;
                width: 20px;
                height: 20px;
                outline: none;
            }

            .status {
                width: 40px;
                height: 40px;
                margin: 0 15px;
                border-radius: 50%;
                background: #0084ff;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 0;
                    border-radius: 50%;
                }
            }

            .next {
                transform: rotateY(180deg);
            }
        }

        .other-btns {
            width: 400px;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
        }

        .time-info {
            width: 120px;
            text-align: center;
        }

        .volume-btns {
            display: block;
            width: 20px;
            height: 20px;
            margin: 0 10px;
        }

        .catelog-btns {
            width: 20px;
            height: 20px;
            margin-right: 18px;
        }
    }

    .catelog-list-mask {
        width: 480px;
        background: saddlebrown;
        height: fit-content;
        position: absolute;
        bottom: 80px;
        right: 0;
        transition: max-height .2s;
        overflow: hidden;
    }

    .catelog-list-body {
        width: 480px;
        height: fit-content;
        max-height: 280px;
        overflow: hidden;
        background: #363c43;
        color: rgba(255, 255, 255, .87);
    }

    .catelog-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border-top: 1px solid rgba(110,120,130,0.15);
        font-size: 14px;
        height: 40px;
        cursor: pointer;

        i {
            display: block;
            width: 40px;
            font-style: normal;
            text-align: center;
        }

        p {
            
            font-size: 13px;
            width: 400px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .delete-icon {
            display: block;
            width: 10px;
            height: 10px;
        }
    }

    .catelog-item:first-child {
        border-top-color: transparent;
    }

    .volume-actives-mask {
        width: 30px;
        height: 130px;
        position: absolute;
        right: 43px;
        bottom: 45px;
        z-index: 4;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
        transition: max-height .2s .1s;

        .has-arrow-wrapper {
            width: 30px;
            height: 120px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: #fff;
        }

        .volume-progress {
            width: 2px;
            height: 100px;
            background: gray;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
        }

        .volume-percent {
            max-height: 100px;
            width: 100%;
            background: red;
        }

        .volume-percent-empty {
            width: 100%;
            background: red;
            height: 5px;
        }

        .volume-drag-point {
            width: 12px;
            height: 5px;
            background: red;
            margin-left: -5px;
            cursor: pointer;
        }
    }

    .has-arrow-wrapper::after {
        content: "";
        position: absolute;
        top: 120px;
        left: 7px;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 5px solid #fff;
    }

    .loadingKeyFrame {
        animation: loadingRotate 1s linear infinite;
    }


</style>
